import * as React from 'react';
import { ServerAssignmentFields_assignments } from '../../../../fragments/__generated__/ServerAssignmentFields';

interface SelectedRowProps {
  selected: ServerAssignmentFields_assignments[];
}

export const SelectedRow = (props: SelectedRowProps) => {
  const selections = props.selected
    .map((selected) => `${selected.parents.map((parent) => parent.name).join(' ')} ${selected.location.name}`)
    .join(', ');

  return (
    <p className='m-0'>
      <b>Selected:</b> {props.selected.length === 0 ? 'None' : selections}
    </p>
  );
};
